import { __makeTemplateObject } from "tslib";
import { css, palette2 } from '../../../../foundation';
import { RcStepConnectorClasses } from '../utils';
export var StepConnectorStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .", " {\n        border-color: ", ";\n      }\n    "], ["\n      .", " {\n        border-color: ", ";\n      }\n    "])), RcStepConnectorClasses.line, palette2('neutral', 'l02'));
};
var templateObject_1;
